export default "__VITE_ASSET__ltVOr6Uc__"